import FightersRegister from '../layouts/Register.vue'
import GroupRegister from '../layouts/RegisterGroup.vue'
import FightersUpdate from '../layouts/Update.vue'
import GroupUpdate from '../layouts/GroupUpdate.vue'
import { dataGroups } from '../store/groups'
import StudentsView from '../StudentsView.vue'

export const fightersRoutes = [
  {
    path: '/fighters',
    name: 'fighters',
    component: StudentsView,
    beforeEnter: (to, from, next) => {
      if (from.meta.tabS == 'tabStudent') {
        dataGroups.dispatch('setTabActivatedstudents', true)
      } else if (from.meta.tabS == 'tabGroups') {
        dataGroups.dispatch('setTabActivatedstudents', false)
      }

      if (!localStorage.__access) next({ name: 'login' })
      next()
    },
    meta: {
      key: 'view_col'
    }
  },
  {
    path: '/fighters/new',
    name: 'new-fighters',
    component: FightersRegister,
    beforeEnter: (to, from, next) => {
      if (!localStorage.__access) next({ name: 'login' })
      next()
    },
    meta: {
      key: 'add_col',
      tabS: 'tabStudent'
    }
  },
  {
    path: '/fighters/edit/:id',
    name: 'edit-fighters',
    component: FightersUpdate,
    beforeEnter: (to, from, next) => {
      if (!localStorage.__access) next({ name: 'login' })
      next()
    },
    meta: {
      key: 'edit_col'
    }
  },
  {
    path: '/group/edit/:id',
    name: 'edit-group',
    component: GroupUpdate,
    beforeEnter: (to, from, next) => {
      if (!localStorage.__access) next({ name: 'login' })
      next()
    },
    meta: {
      key: 'edit_col'
    }
  },
  {
    path: '/group/new',
    name: 'new-group',
    component: GroupRegister,
    beforeEnter: (to, from, next) => {
      if (!localStorage.__access) next({ name: 'login' })
      next()
    },
    meta: {
      key: 'add_col',
      tabS: 'tabGroups'
    }
  }
]
